<template>
  <bm-dropdown
    :auto-select-first="true"
    allow-custom-value
    v-bind="$attrs"
    :value="value"
    :items="countryNames"
    :filter-fields="[filterField]"
    :sort-items="false"
    autocomplete="off-should-mean-off-but-browsers-disagree"
    @change="emit('update:value', $event)"
  />
  <!-- Browsers have very selective behaviour for `autocomplete="off"`, so use a random string to completely prevent it instead -->
</template>

<script setup lang="ts">
import { getCountryNames } from "@/plugins/i18nCountries";
import userStore from "@/store/modules/userStore";
import { computed } from "vue";

interface ICountry {
  filterField: string;
  text: string;
  value: string;
}

interface BmCountryProps {
  value: string;
}

interface BmCountryEvents {
  (event: "update:value", value: string): void;
}

defineProps<BmCountryProps>();
const emit = defineEmits<BmCountryEvents>();

const filterField = (item: ICountry) => item.filterField;

const countryNames = computed((): ICountry[] => {
  let countries: ICountry[] = [];
  const names = getCountryNames(userStore.state.userLanguage);

  // Add the first value if exists
  let defaultCountryName = names.find(
    (name) => name == userStore.state.country
  );

  if (defaultCountryName) {
    if (!Array.isArray(defaultCountryName)) {
      defaultCountryName = [defaultCountryName];
    }
    countries.push({
      filterField: defaultCountryName.join(" "),
      text: defaultCountryName[0],
      value: defaultCountryName[0],
    });
  }

  // Some countries contain multiple values so we take the first and use the others as filter values.
  names
    .sort((a, b) => (a > b ? 1 : -1))
    .map((countryData) => {
      let items;
      if (Array.isArray(countryData)) {
        items = countryData;
      } else {
        items = [countryData];
      }

      countries.push({
        filterField: items.join(" "),
        text: items[0],
        value: items[0],
      });
    });

  return countries;
});
</script>
